// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//   // Check if a token exists in localStorage
//   const token = localStorage.getItem('token');
//   const location = useLocation();

//   // If no token, redirect to /login.
//   if (!token) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   // Otherwise, render the children (protected component)
//   return children;
// };

// export default ProtectedRoute;






// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";


// const ProtectedRoute = ({ children, type = "user" }) => {
//   const location = useLocation();

//   let token = null;
//   let loginPath = "/login";

//   if (type === "admin") {
//     token = localStorage.getItem("adminToken");
//     loginPath = "/HelpNaoadminpannel/login";
//   } else if (type === "servitor") {
//     // for now servitor & normal user share the same "token"
//     token = localStorage.getItem("token");
//     loginPath = "/login"; // your normal Login page handles servitor/user by role
//   } else {
//     // normal user
//     token = localStorage.getItem("token");
//     loginPath = "/login";
//   }

//   if (!token) {
//     return <Navigate to={loginPath} state={{ from: location }} replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;














import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, type = "user" }) => {
  const location = useLocation();

  const userToken  = localStorage.getItem("token");
  const adminToken = localStorage.getItem("adminToken");

  const rawRole = localStorage.getItem("role") || "";
  const role = rawRole.trim().toLowerCase();  // "user" | "servitor" | "admin" | ""

  let token = null;
  let loginPath = "/login";

  if (type === "admin") {
    token = adminToken;
    loginPath = "/HelpNaoadminpannel/login";
  } else {
    token = userToken;
    loginPath = "/login";
  }

  // 1) No token → redirect to correct login
  if (!token) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // 2) Role-based checks

  // /profile/* ⇒ only normal users
  if (type === "user") {
    if (role === "servitor") {
      return <Navigate to="/servitor" replace />;
    }
    if (role === "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  // /servitor/* ⇒ only servitors
  if (type === "servitor") {
    if (role !== "servitor") {
      return <Navigate to="/login" replace />;
    }
  }

  // /admin/* ⇒ only admins
  if (type === "admin") {
    if (role !== "admin") {
      return <Navigate to="/HelpNaoadminpannel/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
